import { ENDPOINTS } from "@/settings/api-settings";
import { Observable, from } from "rxjs";
import { map } from "rxjs/operators";
import { apiClient } from "./api";

import * as webauthnJson from "@github/webauthn-json";
import { setToken } from "./session-data";
const fs = require('fs')

export function isFingerprintAvailable(): Promise<Boolean> {
  return PublicKeyCredential && PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable();
}

function initWebauthnRegistration(): Observable<any> {
  return from(apiClient.get(ENDPOINTS.WEBAUTHN_REGISTRATION)).pipe(map((r: any) => (!!r.data ? r.data : {})));
}

function createWebauthnRegistration(options: any): Promise<any> {
  return webauthnJson.create(options);
}

function finishWebauthnRegistration(credential: any): Observable<any> {
  return from(apiClient.post(ENDPOINTS.WEBAUTHN_REGISTRATION, credential)).pipe(map((r: any) => (!!r.data ? r.data : {})));
}

export function registerFingerprint(): Promise<any> {
  return isFingerprintAvailable().then(r => {
    if (!r) {
      throw new Error('Não tem acesso a biometria')
    }
    if (isFingerprintRegistered()) {
      throw new Error('Biometria ja cadastrada')
    }
  }).then(() => {
    return initWebauthnRegistration().toPromise();
  }).then(options => {
    return createWebauthnRegistration(options);
  }).then(publicKey => {
    return finishWebauthnRegistration(publicKey).toPromise();
  }).then(result => {
    setFingerprintRegistered(true);
    return result;
  }).catch(error => {
    throw error;
  });
}

function initWebauthnAuthentication(username: string): Observable<any> {
  return from(apiClient.get(ENDPOINTS.WEBAUTHN_PRE_AUTHENTICATION, { username }, true)).pipe(map((r: any) => (!!r.data ? r.data : {})));
}

function getWebauthnAuthentication(options: any): Promise<any> {
  return webauthnJson.get(options);
}

function finishWebauthnAuthentication(credential: any): Observable<any> {
  return from(apiClient.post(ENDPOINTS.WEBAUTHN_AUTHENTICATION, credential));
}

export function authenticateByFingerprint(username: string): Promise<any> {
  return isFingerprintAvailable().then(r => {
    return r;
  }).then(fingerprint => {
    if (!fingerprint) {
      return false;
    }
    setFingerprintRegistered(false);
    return initWebauthnAuthentication(username).toPromise();
  }).then(options => {
    return getWebauthnAuthentication(options);
  }).then(publicKey => {
    setFingerprintRegistered(true);
    return finishWebauthnAuthentication(publicKey).toPromise();
  }).then(response => {
    const token = !!response.headers ? response.headers.authorization : null;
    setToken(token);
  }).catch(error => {
    setFingerprintRegistered(false);
    throw(error);
  });
}


function setFingerprintRegistered(value: boolean) {
  sessionStorage.setItem('haswebauth', String(value));
}

export function isFingerprintRegistered(): boolean {
  let val = sessionStorage.getItem('haswebauth');
  return val != null && val == 'true';
}